import React, { useState } from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { injectIntl, IntlShape } from 'react-intl';

import messages from 'containers/LawyerLegalProceedingsPage/AppealAdd/messages';
import { translate } from 'containers/services/translate';
import { Wrapper } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/styled-components';
import JudgementAddForms from 'containers/LawyerLegalProceedingsPage/AppealAdd/AppealAddPronouncing/AppealAddForms';
import { Listings } from 'containers/AppContainer/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import EmptyAddFormBloc from 'components/EmptyAddFormBloc';
import { AppealAddDocType } from 'containers/LawyerLegalProceedingsPage/AppealAdd/constants';
import { VictimType } from 'typings/globalTypes';
export interface JudgementAddPronouncingProps {
  intl: IntlShape;
  listings: Listings;
  setJudgementAddDocuments: Function;
  judgementAddDocuments: JudgementADDDocumentType[];
  victims: VictimType[];
  vehicules: Vehicule[];
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  disabled: boolean;
  document: AppealAddDocType;
  setDocument: Function;
  details: any;
  judiciaryProcessId?: number;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  claimAssignment?: any;
  feeNotes?: any;
  setOpenFeeNoteDialog: Function;
  imagineDocuments: any;
  claimId: number;
  policyInfo: any;
  requestGetDocByDocumentumId: Function;
}

const AppealAddPronouncing: React.FC<JudgementAddPronouncingProps> = (
  props,
): JSX.Element => {
  const [isAddJudgementAddFormOn, setIsAddJudgementAddFormOn] = useState<
    boolean
  >(false);

  const handleAddButton = () => {
    setIsAddJudgementAddFormOn(true);
  };

  return (
    <Wrapper>
      <section className="content">
        <div className="pronounce-add-bloc-title">
          {translate(messages.appealAddPronouncingTitle, props)}
        </div>
        {!isAddJudgementAddFormOn && (
          <EmptyAddFormBloc
            title={translate(messages.appealAddPronouncingSubtitle, props)}
            buttonBlocTitle={translate(messages.addButton, props)}
            icon={<AddCircleOutlineIcon className="icon" />}
            handleClick={handleAddButton}
            disabled={props.disabled}
          />
        )}

        {isAddJudgementAddFormOn && (
          <JudgementAddForms
            listings={props.listings}
            document={props.document}
            setDocument={props.setDocument}
            judgementAddDocuments={props.judgementAddDocuments}
            setJudgementAddDocuments={props.setJudgementAddDocuments}
            victims={props.victims}
            details={props.details}
            vehicules={props.vehicules}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            setIsAddJudgementAddFormOn={setIsAddJudgementAddFormOn}
            judiciaryProcessId={props.judiciaryProcessId}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            claimAssignment={props.claimAssignment}
            feeNotes={props.feeNotes}
            setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
            imagineDocuments={props.imagineDocuments}
            claimId={props.claimId}
            policyInfo={props.policyInfo}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}
      </section>
    </Wrapper>
  );
};

export default injectIntl(AppealAddPronouncing);
